import React from 'react'
import IncomeAttributeLookupObject from '../../../types/lookups/IncomeAttributeLookupObject'
import IncomeAttributeTableFragmentGenerator from '../../../utils/TableGenerator/IncomeAttributeTableFragmentGenerator'
import { defaultMatcher } from '../../../utils/context/FormErrorContext'

interface RoomStatisticsTabProps {
    valueChangeHandler: (newAmt: number | undefined | null, name: string, oldAmt: number | undefined | null) => void,
    lookups: IncomeAttributeLookupObject[],
    data: Record<string, number | null>,
}

function RoomStatisticsTab(props: RoomStatisticsTabProps) {
    const { valueChangeHandler, lookups, data } = props
    return (
        <>
            { (lookups && data) && 
                <table className="table-with-border pie-table" role="presentation">
                    <thead>
                        <tr>
                            <th id="attribute-label" scope="col"></th>
                            <th id="income-attribute-value-header" scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {lookups.map((attr, key) => {
                            if (["numberOfRoom", "roomAvailable"].includes(attr.incomeAttributeCode)) {
                                return <IncomeAttributeTableFragmentGenerator key={key} attribute={attr}
                                    data={{ "value": data[attr.incomeAttributeCode] }}
                                    valueChangeHandler={valueChangeHandler}
                                    handleCommentChange={() => null}
                                    showSubheading={false}
                                    hasInputLabel={false}
                                    isOtherLabel={false}
                                    isRequiredField={true}
                                    isReplacementReserve={false}
                                    tooltip={attr.tooltip}
                                    isProfileAttribute={true}
                                    fieldType='integer'
                                    errorMatcher={defaultMatcher} />
                            } else if (["roomSold"].includes(attr.incomeAttributeCode)) {
                                return <IncomeAttributeTableFragmentGenerator key={key} attribute={attr}
                                    data={{ "value": data[attr.incomeAttributeCode] }}
                                    valueChangeHandler={valueChangeHandler}
                                    handleCommentChange={() => null}
                                    showSubheading={false}
                                    hasInputLabel={false}
                                    isOtherLabel={false}
                                    isRequiredField={false}
                                    isReplacementReserve={false}
                                    tooltip={attr.tooltip}
                                    isProfileAttribute={true}
                                    fieldType='integer'
                                    errorMatcher={defaultMatcher} />
                            } else if (attr.incomeAttributeCode === "occupancyPercent") {
                                return <IncomeAttributeTableFragmentGenerator key={key} attribute={attr}
                                    data={{ "percent": data[attr.incomeAttributeCode] }}
                                    valueChangeHandler={valueChangeHandler}
                                    handleCommentChange={() => null}
                                    showSubheading={false}
                                    hasInputLabel={false}
                                    isOtherLabel={false}
                                    isRequiredField={true}
                                    isReplacementReserve={false}
                                    tooltip={attr.tooltip}
                                    isProfileAttribute={true}
                                    fieldType='percent'
                                    errorMatcher={defaultMatcher}
                                    maxVal={true} />
                            } else {
                                return <IncomeAttributeTableFragmentGenerator key={key} attribute={attr}
                                    data={{ "value": data[attr.incomeAttributeCode] }}
                                    valueChangeHandler={valueChangeHandler}
                                    handleCommentChange={() => null}
                                    showSubheading={false}
                                    hasInputLabel={false}
                                    isOtherLabel={false}
                                    isRequiredField={true}
                                    isReplacementReserve={false}
                                    tooltip={attr.tooltip}
                                    isProfileAttribute={true}
                                    errorMatcher={defaultMatcher} />
                            }
                        })
                        }
                    </tbody>
                </table>
            }
        </>
    )
}

export default RoomStatisticsTab